const defaultError = 'Kolom {_field_} invalid value';
const vee = require('vee-validate/dist/locale/id').messages;

const custom_rules = {
  phone: defaultError,
  required: 'Harus diisi',
  ip: 'The {_field_} Kolom wajib valid IP address',
  pbx_internal_number: 'Kolom {_field_} sudah terisi',
  latin_num: 'Kolom {_field_} Hanya untuk alphabet and nomor',
  latin_num_ext: 'Kolom {_field_} Hanya untuk alphabet and nomor and karater khusus (.,-_).',
  login: 'Kolom {_field_} Hanya untuk alphabet, nomor and garis bawah',
  accepted: 'Kolom{_field_} wajib di terima',
  oneOf: 'Kolom {_field_} wajib valid ({values})',
  mimes: 'Kolom{_field_} wajib valid ({values})',
  ext: 'Kolom {_field_} wajib valid  ({values})',
  password: `The password hanya untuk alphabet and nomor minimal satu hurup atau angka besar.`,
  sms_count: 'Untuk encoding {encoding}, a character dilimitasi: {max_symbol_count}',
  url_ip: 'The field format is invalid',
  old_date: 'The date must be later than the current date',
  check_current_password: 'Kata sandi saat ini salah',
  need_scheme: 'Diperlukan untuk membuat skema'
};

const laravel_rules = {
  active_url: 'Kolom {_field_} URL tidak valid',
  after: 'Kolom {_field_} tanggal setelah {date}',
  after_or_equal: 'Kolom {_field_} harus tanggal setelah atau sama dengan {date}',
  array: 'Kolom {_field_} harus sesuai sususan',
  before: 'Kolom {_field_} tanggal sebelum {date}',
  before_or_equal: 'Kolom {_field_} harus tanggal sebelum atau sama dengan {date}',
  boolean: 'Kolom{_field_}  harus benar',
  confirmed: 'Kolom {_field_} konfirmasi field tidak sesuai',
  date: 'Kolom {_field_} bukan tanggal yang valid',
  date_equals: 'Kolom {_field_} harus sama dengan tanggal {date}',
  date_format: 'Kolom {_field_} tidak sesuai dengan format {format}',
  different: 'Kolom {_field_} harus berbeda dengan kolom{other}',
  digits_between: 'Kolom {_field_} harus antara nilai {min} and {max} digits',
  dimensions: 'Kolom {_field_} memiliki dimensi gambar yang tidak valid',
  distinct: 'Kolom {_field_} memiliki nilai kesamaan',
  ends_with: 'Kolom {_field_} harus diakhiri dengan salah satu dari berikut ini: {values}',
  exists: 'Kolom yang dipilih{_field_} tidak valid',
  file: 'Kolom {_field_} harus berupa file',
  filled: 'Kolom {_field_} harus ada nilai',
  image: 'Kolom {_field_} harus ada gambar',
  in_array: 'Kolom {_field_} tidak ada di {other}',
  ipv4: 'Kolom {_field_} harus valid IPv4 address',
  ipv6: 'Kolom {_field_} harus valid IPv6 address',
  json: 'Kolom {_field_} harus valid JSON string',
  not_in: 'Kolom yang dipilih {_field_} tidak valid',
  not_regex: vee.regex,
  present: 'Kolom {_field_} harus ada',
  required_if: 'Kolom {_field_}  harus diisi bila {other} adalah {value}',
  required_recipient: 'Kolom {_field_} harus diisi',
  required_unless: 'Kolom {_field_} harus diisi kecuali {other} ada di {values}',
  required_with: 'Kolom {_field_} harus diisi jika {values} ada dengan',
  required_with_all: 'Kolom {_field_} harus diisi jika {values} ada semua',
  required_without: 'Kolom {_field_} harus diisi jika {values} tidak ada',
  required_without_all: 'The {_field_} harus diisi bila tidak ada {values} di dalamnya',
  same: 'Kolom{_field_} dan lainnya {other} harus sesuai',
  starts_with: 'Kolom{_field_} harus dimulai dengan salah satu dari berikut ini: {values}',
  string: 'Kolom {_field_} harus berupa string',
  timezone: 'Kolom{_field_} harus merupakan zona yang valid',
  unique: 'Kolom {_field_} sudah ada kesamaan',
  url: 'Kolom{_field_} tidak valid',
  uuid: 'Kolom{_field_} harus valid UUID',
  max: 'Tidak boleh lebih dari {length} karakte',
  min: 'Minimal mengandung {length} karakter'
};

const size_laravel_rules = {
  between: {
    numeric: 'Kolam {_field_} harus antara {min} dan {max}',
    file: 'Kolam  {_field_} harus antara {min} dan {max} kilobytes',
    string: 'Kolam  {_field_} harus antara {min} dan {max} karakter',
    array: 'Kolam  {_field_} harus antara {min} dan {max} items'
  },
  gt: {
    numeric: 'Kolam {_field_} harus lebih besar dari {size}',
    file: 'Kolam {_field_} harus lebih besar dari {size} kilobytes',
    string: 'Kolam  {_field_} harus lebih besar dari {size} karakter',
    array: 'Kolam  {_field_} harus lebih besar dari {size} items'
  },
  gte: {
    numeric: 'Kolam {_field_} harus lebih besar dari or equal {size}',
    file: 'Kolam  {_field_} harus lebih besar dari or equal {size} kilobytes',
    string: 'Kolam  {_field_} harus lebih besar dari or equal {size} karacters',
    array: 'Kolam {_field_} harus lebih besar dari {size} items atau lebih'
  },
  lt: {
    numeric: 'Kolam  {_field_} harus lebih kurang dari {size}',
    file: 'Kolam  {_field_} harus lebih kurang dari {size} kilobytes',
    string: 'Kolam  {_field_} harus lebih kurang dari {size} karakter',
    array: 'Kolam {_field_} harus lebih kurang dari {size} items'
  },
  lte: {
    numeric: 'Kolam  {_field_} harus lebih kurang dari atau sama dengan {size}',
    file: 'Kolam  {_field_} harus lebih kurang dari or equal {size} kilobytes',
    string: 'Kolam  {_field_} harus lebih kurang dari or equal {size} karakters',
    array: 'Kolam  {_field_} harus lebih kurang dari {size} items'
  },
  max: {
    numeric: 'Kolam  {_field_} harus tidak lebih besar dari {size}',
    file: 'Kolam {_field_} harus tidak lebih besar dari {size} kilobytes',
    string: 'Kolam  {_field_} harus tidak lebih besar dari {size} characters',
    array: 'Kolam  {_field_} harus tidak lebih besar dari {size} items'
  },
  min: {
    numeric: 'Kolam  {_field_} harus setidaknya berukuran {size}',
    file: 'Kolam {_field_} harus setidaknya berukuran {size} kilobytes',
    string: 'Kolom {_field_} harus setidaknya berukuran {size} karakter',
    array: 'Kolom {_field_} harus setidaknya berukuran {size} items'
  },
  size: {
    numeric: 'Kolom {_field_} harus berukuran {size}',
    file: 'Kolom {_field_} harus berukuran  {size} kilobytes',
    string: 'Kolom {_field_} harus berukuran  {size} karakter',
    array: 'Kolom {_field_} harus berisi {size} items'
  }
};

const custom_laravel_rules = {
  sip_account_with_caller_id_limit: 'Anda tidak dapat membuat lebih dari {size} SIP accounts dengan caller_id',
  action_link: 'Anda tidak dapat membuat link',
  action_menu: 'Anda tidak dapat membuat lebih dari {size} menus',
  client_config_record_outgoing: 'Call recording is not available for this package',
  contact_limit: 'Anda tidak dapat membuat lebih dari {size} contacts',
  contact_method_limit: 'Anda tidak dapat membuat lebih dari {size} contact methods',
  entry_point_record_type: 'Call recording tidak tersedia pada paket ini',
  sms_verification: 'Error SMS verifikasi',
  check_balance: 'Dana tidak mencukupi',
  change_package_limit: 'PBX service hanya bisa diganti sehari sekali'
};

export const rules = Object.assign({}, vee, custom_rules, laravel_rules, custom_laravel_rules, {
  laravel: size_laravel_rules
});
